import { IRequestOptions } from 'peekdata-datagateway-api-sdk';
import { BaseApi } from 'peekdata-datagateway-api-sdk/lib/api/base';
import { ILoginResponse, IUser } from 'src/models/user';

export class UsersApi extends BaseApi {

  /**
   * Gets user session ID needed to work with Report Builder
   */
  public login = (userName: string, password: string, requestOptions?: IRequestOptions) => {
    return this.get<ILoginResponse>({
      path: '/user/login',
      params: [
        { key: 'userName', value: userName },
        { key: 'password', value: password },
      ],
      requestOptions,
    });
  }

  /**
   * Validates user session.
   * Returns "true" if operation is successful or "false" if something went wrong.
   * Each validation of session prolongs it for 15 minutes, meaning session would be expired if not prolonged after 15 minutes.
   */
  public validateSession = (sessionID: string, requestOptions?: IRequestOptions) => {
    return this.get<boolean>({
      path: '/user/validateSession',
      params: [
        { key: 'sessionID', value: sessionID },
      ],
      requestOptions,
    });
  }

  /**
   * Gets current user information
   */
  public getCurrentUser = (sessionID: string, requestOptions?: IRequestOptions) => {
    return this.get<IUser>({
      path: '/user/get',
      params: [
        { key: 'sessionID', value: sessionID },
      ],
      requestOptions,
    });
  }

  /**
   * Logs out and makes user session invalid
   */
  public logout = (sessionID: string, requestOptions?: IRequestOptions) => {
    return this.post<void>({
      path: '/user/logout',
      params: [
        { key: 'sessionID', value: sessionID },
      ],
      requestOptions,
    });
  }
}
